import { render, staticRenderFns } from "./maintenance-order-open-list.vue?vue&type=template&id=28ff35d3"
import script from "./maintenance-order-open-list.vue?vue&type=script&lang=js"
export * from "./maintenance-order-open-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports